// Ported from packages/desk/src/mobile/Dock.tsx (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/**
 * The phone's dock: three or four tools that are never a copy of the home apps. Home, Search, the host's own tool
 * (with its badge) and Profile. The one in use takes the accent.
 */
import type { ReactNode } from "react";
import { HomeGlyph, ProfileGlyph, SearchGlyph } from "./glyphs";
import { formatBadge } from "./layout";
import type { MobileDockTool } from "./types";

export type DockSlot = "home" | "search" | "profile" | "tool" | null;

export function Dock({ active, tool, onHome, onSearch, onProfile }: { active: DockSlot; tool?: MobileDockTool | null | undefined; onHome: () => void; onSearch: () => void; onProfile: () => void }) {
  const b = formatBadge(tool?.badge);
  const item = (slot: Exclude<DockSlot, null>, label: string, icon: ReactNode, run: () => void, badge?: ReactNode, aria?: string) => (
    <button type="button" className={"rdr-mdock-item" + (active === slot ? " active" : "")} aria-current={active === slot ? "page" : undefined} aria-label={aria ?? label} data-rdr-dock-item={slot === "tool" ? tool?.id : slot} onClick={run}>
      <span className="rdr-mdock-ic" aria-hidden="true">
        {icon}
        {badge}
      </span>
      <span className="rdr-mdock-label" aria-hidden="true">
        {label}
      </span>
    </button>
  );
  return (
    <nav className="rdr-mdock" aria-label="Dock" data-rdr-mobile-dock="">
      {item("home", "Home", <HomeGlyph />, onHome)}
      {item("search", "Search", <SearchGlyph />, onSearch)}
      {tool &&
        item(
          "tool",
          tool.label,
          tool.icon,
          tool.onOpen,
          b.kind === "count" ? <span className="rdr-mbadge">{b.text}</span> : b.kind === "dot" ? <span className="rdr-mbadge dot" /> : null,
          b.kind === "count" ? `${tool.label}, ${b.n}` : b.kind === "dot" ? `${tool.label}, something new` : tool.label,
        )}
      {item("profile", "Profile", <ProfileGlyph />, onProfile)}
    </nav>
  );
}
